import { customElement, scss } from '../../core/ids-decorators';
import { attributes } from '../../core/ids-attributes';
import { getClosest } from '../../utils/ids-dom-utils/ids-dom-utils';

import IdsEventsMixin from '../../mixins/ids-events-mixin/ids-events-mixin';
import IdsLocaleMixin from '../../mixins/ids-locale-mixin/ids-locale-mixin';

import IdsMenuGroup from '../ids-menu/ids-menu-group';

import './ids-sub-tab';
import styles from './ids-sub-tabs.scss';
import type IdsTabs from './ids-tabs';
import type IdsTab from './ids-tab';
import type IdsSubTab from './ids-sub-tab';

const Base = IdsLocaleMixin(
  IdsEventsMixin(
    IdsMenuGroup
  )
);

/**
 * IDS Sub Tabs
 * @type {IdsSubTabs}
 * @inherits IdsMenuGroup
 * @mixes IdsEventsMixin
 * @mixes IdsLocaleMixin
 */
@customElement('ids-sub-tabs')
@scss(styles)
export default class IdsSubTabs extends Base {
  constructor() {
    super();
  }

  /**
   * Return the attributes we handle as getters/setters
   * @returns {Array} The attributes as an array
   */
  static get attributes() {
    return [
      attributes.KEEP_OPEN,
      attributes.SELECT,
      attributes.WRAP
    ];
  }

  connectedCallback() {
    super.connectedCallback();
    this.#attachEventHandlers();
  }

  template() {
    return `<div class="ids-sub-tabs" role="none"><slot></slot></div>`;
  }

  /**
   * Establish internal event handlers
   * @private
   * @returns {object} The object for chaining
   */
  #attachEventHandlers() {
    this.onEvent('click.sub-tabs', this, (e: PointerEvent) => {
      const elem: any = e.target;
      if (!elem) return;

      if (elem.tagName === 'IDS-TRIGGER-BUTTON' || getClosest(elem, 'ids-trigger-button')) {
        e.stopPropagation();
        const tab = getClosest(elem, 'ids-sub-tab');
        this.#dismissTab(tab);
      }
    });

    // Removes the tab from the list on `tabremove` events
    this.onEvent('subtabremove', this, (e: CustomEvent) => {
      e.detail.elem.remove();
    });
    return this;
  }

  /**
   * Dismisses (removes) a Tab from the Tab List
   * @param {any} tab the new tab to select
   * @returns {void}
   */
  #dismissTab(tab: any): void {
    if (!tab) return;

    tab.dismiss();
  }

  removeSelectedSubTab(): void {
    const rootNode = (this.getRootNode() as any).host.parentElement as IdsTabs;
    if (rootNode) {
      const tabsWithSubTabs = rootNode.querySelectorAll('ids-tab[sub-tabs]');
      for (let i = 0; i < tabsWithSubTabs.length; i++) {
        const targetTab: IdsTab | any = tabsWithSubTabs[i];
        const selectedSubTab: IdsSubTab | any = targetTab.shadowRoot.querySelector('ids-sub-tab[selected]');
        if (selectedSubTab) {
          selectedSubTab.selected = false;
        }
      }
    }
  }
}
